import React, { createContext, useEffect, useState, useContext } from "react";
import { getSettings } from "../api/common";
import { useQuery, useQueryClient } from "@tanstack/react-query";

export const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
  const queryClient = useQueryClient();

  const { data: settings, } = useQuery({
    queryKey: ["applicationSettings"], 
    queryFn: getSettings,
    select: (response) => response.data,
    staleTime: 1000 * 60 * 5, 
  });

  return (
    <SettingsContext.Provider value={{ settings}}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
